if (window.GA4) {
  // const googleAnalytics = function(event) {
  //   window.dataLayer = window.dataLayer || [];
  //   function gtag(){dataLayer.push(arguments);}
  //   gtag('js', new Date());
  //   gtag('config', window.GA4, { page_location: event.detail.url });
  // }
  // document.addEventListener('turbo:load', googleAnalytics, false)

  const sendPageView = () => {
    if (typeof gtag === 'function') {
      gtag('event', 'page_view', {
        page_location: window.location.href,
        page_path: window.location.pathname + window.location.search,
        page_title: document.title
      })
    }
  }

  // Fire on initial load and every Turbo visit.
  document.addEventListener('turbo:load', sendPageView, false)
}